// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"32ecab2e","147":"48198676","563":"da9b14de","574":"d0221ff1","807":"51adf6da","818":"0b2b5ff6","900":"815301c4","996":"6f181391"}[chunkId] + ".chunk.js";
};